/**
 * @generated SignedSource<<d71d2b7baf0cb219c867813927a678df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView$data = {
  readonly id: string;
  readonly selectedOption: {
    readonly label: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView";
};
export type radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView$key = {
  readonly " $data"?: radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        {
          "alias": "label",
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "type": "JiraRadioSelectField"
};

(node as any).hash = "b7cbd05b4ede163325935a84f69fdb87";

export default node;
